import {IpcMain, IpcMainInvokeEvent, IpcRenderer, IpcRendererEvent} from "electron";

export type EventListener<T> = (event: IpcRendererEvent, content: T) => any;
export type EventHandler<T> = (event: IpcMainInvokeEvent, content: T) => any;

export default class EventDispatcher<T> {
    public constructor(
        private eventEmitter: IpcMain,
        private eventSender: IpcRenderer
    ) {
    }

    public addListener(channel: string, listener: EventListener<T>): void {
        try {
            this.eventSender.on(channel, listener);
        } catch (error) {
            return;
        }
    }

    public addHandler(channel: string, listener: EventHandler<T>): void {
        try {
            this.eventEmitter.handle(channel, listener);
        } catch (error) {
            return;
        }
    }

    public removeListener(channel: string, listener: EventListener<T>): void {
        try {
            this.eventSender.removeListener(channel, listener);
        } catch (error) {
            return;
        }
    }

    public removeHandler(channel: string): void {
        try {
            this.eventEmitter.removeHandler(channel);
        } catch (error) {
            return;
        }
    }

    public async dispatch(event: string, content: T | null = null): Promise<any> {
        return await this.eventSender.invoke(event, content);
    }
}